// extracted by mini-css-extract-plugin
export default {"main":"crPasw_main__a+Wft","text":"crPasw_text__hew9+","form":"crPasw_form__LHSpI","error":"crPasw_error__0OYtP"};